export const DISBURSEMENT_AMOUNT = 'Disbursement Amount';
export const LAND_ONLY_AMOUNT = 'Land Only Amount';

export const TAX_DISBURSEMENT_OPTIONS = {
  purchase: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Not Escrowed', value: 10 },
    {
      label: 'Borrower to Pay at Closing',
      value: 2,
    },
    { label: 'Seller to Pay at Closing', value: 0 },
  ],
  refinance: [
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
  trackPlus: [
    { label: ' ', value: null },
    { label: 'Past Bill - Pay at Closing', value: 8 },
    { label: 'Current Bill - Pay at Closing', value: 9 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
  trackPlusAfterFirstPayment: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Past Bill - Pay at Closing', value: 8 },
    { label: 'Current Bill - Pay at Closing', value: 9 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
  beforeClosing: [
    {
      label: 'Borrower to Pay at Closing',
      value: 2,
    },
    { label: 'Seller to Pay at Closing', value: 0 },
    { label: 'Paid in Full', value: 6 },
  ],
  beforeClosingRefi: [
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
  afterFirstPaymentRefi: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Not Escrowed', value: 10 },
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Delinquent', value: 1 },
  ],
};

export const PAST_TAX_DISBURSEMENT_OPTIONS = {
  purchase: [
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Seller to Pay at Closing', value: 0 },
    { label: 'Paid in Full', value: 6 },
  ],
  refinance: [
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
  tracPlus: [
    { label: 'Past Bill - Pay at Closing', value: 8 },
    { label: 'Current Bill - Pay at Closing', value: 9 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Delinquent', value: 1 },
  ],
};

export const FUTURE_TAX_DISBURSEMENT_OPTIONS = {
  others: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Not Escrowed', value: 10 },
  ],
  purchase: [
    {
      label: 'Collect in Escrow',
      value: 3,
    },
    {
      label: 'Not Escrowed',
      value: 10,
    },
    {
      label: 'Borrower to Pay at Closing',
      value: 2,
    },
    {
      label: 'Paid in Full',
      value: 6,
    },
    {
      label: 'Seller to Pay at Closing',
      value: 0,
    },
  ],
  trackPlus: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Not Escrowed', value: 10 },
    { label: 'Paid in Full', value: 6 },
  ],
};

export const SUPPLEMENTAL_TAX_DISBURSEMENT_OPTIONS = {
  NON_TRAC: [
    { label: 'Borrower to Pay at Closing', value: 2 },
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Paid in Full', value: 6 },
    { label: 'Not Escrowed', value: 10 },
  ],
  TRAC: [
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Paid in Full', value: 6 },
  ],
  CURRENT_YEAR: [
    { label: 'Paid in Full', value: 6 },
    { label: 'Collect at Closing', value: 7 },
    { label: 'Collect in Escrow', value: 3 },
    { label: 'Not Escrowed', value: 10 },
  ],
  PREV_YEAR: [
    { label: 'Paid in Full', value: 6 },
    { label: 'Collect at Closing', value: 7 },
  ],
};

export const TAX_PAYMENT_TYPES = {
  SELLER_TO_PAY_AT_CLOSING: 0,
  DELINQUENT: 1,
  BORROWER_TO_PAY_AT_CLOSING: 2,
  COLLECT_IN_ESCROW: 3,
  PAID_DUE_AT_CLOSING: 5,
  PAID_IN_FULL: 6,
  COLLECT_AT_CLOSING: 7,
  PAST_BILL_PAY_AT_CLOSING: 8,
  CURRENT_BILL_PAY_AT_CLOSING: 9,
  NOT_ESCROWED: 10,
} as const;

export const WAIVE_ESCROW_OPTION_DISPLAY_NAMES: Record<number, string> = {
  1: 'No Waiver',
  2: 'Waive Taxes Only',
  3: 'Waive Hazard Insurance Only',
  4: 'Waive Taxes & Hazard Insurance',
};

export const ESCROW_WAIVER_TAX_OPTION_IDS = [2, 4] as const;

export const TAX_DOC_TYPES_LABELS = {
  'TAXINFORMATION-0': 'Tax Information',
  PreliminaryTitleCommitment: 'Title Commitment',
  TAXINFORMATIONCORELOGIC: 'Tax Information CoreLogic',
  'PRE-CLOSINGSTATUSREPORT-TRACLITE': 'Pre-Closing Status Report - TRAC Lite',
  TITLESUMMARY: 'Title Summary',
} as const;

export const CALCULATION_METHODS = {
  MANUAL: 'manual',
  TAX_RATE: 'taxRate',
  MILLAGE_RATE: 'millageRate',
  NOT_PROVIDED: 'notProvided',
} as const;
